export const USERS_ADMIN_TAGS = {
  USERS_ADMIN_TAG: "UsersAdmin",
  USERS_DETAILS_TAG: "UsersDetails",
  USERS_SEARCH_TAG: "UsersSearch",
  USERS_DIRECTORY_TAG: "UsersDirectory",
  USERS_DIRECTORY_DETAILS_TAG: "UsersDirectoryDetails",
  USERS_DIRECTORY_SEARCH_TAG: "UsersDirectorySearch",
};
